module.exports = __webpack_public_path__ + "img/logo_qiniuyun@2x.92a49ec7.png";